import { z } from 'zod';

/// //////////////////////////////////////////////////
/// Model
/// /////////////////////////////////////////////////

const ConsecutiveModel = z.object({
  id: z.string().uuid(),
  fiscalYear: z.number().int(),
});

export const ConsecutiveFiscalYearsModel = ConsecutiveModel.array();

export const ConsecutiveRequestAmountsModel = ConsecutiveModel.extend({
  amount: z.number().nullable(),
  negativeAmountCount: z.number().nullish(),
}).array();
